module.exports = __webpack_public_path__ + "img/acpv_on_load.fcc78b56.png";